module.exports = __webpack_public_path__ + "img/fondo1.eba0a74a.png";